var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Fragment } from 'react';
import { white } from '../../../../colors';
import { ListItem, LinkItem as Link } from '../MobileMenu.styles';
import { ArrowLeft, CollectionTitle, Navigation, ParentLabel, Wrapper, StyledArrowRight } from './MobileSubmenu.styles';

var MobileSubmenu = function MobileSubmenu(_a) {
  var id = _a.id,
      parentLabel = _a.parentLabel,
      submenuRows = _a.submenuRows,
      linkComponent = _a.linkComponent,
      state = __rest(_a, ["id", "parentLabel", "submenuRows", "linkComponent"]);

  return /*#__PURE__*/React.createElement(Wrapper, {
    open: id === state.mobileSubmenuId,
    "data-test": 'header-mobile-submenu'
  }, /*#__PURE__*/React.createElement(Navigation, null, /*#__PURE__*/React.createElement(ParentLabel, {
    onClick: function onClick() {
      return state.setMobileSubmenuId(null);
    }
  }, /*#__PURE__*/React.createElement(ArrowLeft, null), parentLabel), submenuRows.map(function (row) {
    var _a, _b, _c, _d;

    return /*#__PURE__*/React.createElement(Fragment, {
      key: row.id
    }, /*#__PURE__*/React.createElement(CollectionTitle, null, row.title), row.submenuItems.map(function (_a) {
      var itemId = _a.id,
          title = _a.title,
          link = _a.link;
      return /*#__PURE__*/React.createElement(ListItem, {
        key: itemId
      }, /*#__PURE__*/React.createElement(Link, {
        href: link,
        as: linkComponent,
        onClick: function onClick() {
          return state.setMenuOpen(false);
        }
      }, title));
    }), ((_a = row.viewAllLink) === null || _a === void 0 ? void 0 : _a.url) && row.viewAllLink.label ? /*#__PURE__*/React.createElement(ListItem, {
      key: (_b = row.viewAllLink) === null || _b === void 0 ? void 0 : _b.url
    }, /*#__PURE__*/React.createElement(Link, {
      href: (_c = row.viewAllLink) === null || _c === void 0 ? void 0 : _c.url,
      as: linkComponent,
      onClick: function onClick() {
        return state.setMenuOpen(false);
      }
    }, (_d = row.viewAllLink) === null || _d === void 0 ? void 0 : _d.label, /*#__PURE__*/React.createElement(StyledArrowRight, {
      color: white()
    }))) : null);
  })));
};

export default MobileSubmenu;